import React from 'react'

const VuiHorizontalMoreIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="17" height="6" viewBox="0 0 17 6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M2.17499 0.825195C0.980808 0.825195 0 1.806 0 3.00019C0 4.19437 0.980808 5.17518 2.17499 5.17518C3.36893 5.17518 4.34999 4.19437 4.34999 3.00019C4.34999 1.806 3.36893 0.825195 2.17499 0.825195ZM14.825 0.825195C13.6308 0.825195 12.65 1.806 12.65 3.00019C12.65 4.19437 13.6308 5.17518 14.825 5.17518C16.0189 5.17518 17 4.19437 17 3.00019C17 1.806 16.0189 0.825195 14.825 0.825195ZM8.5 0.825967C7.30599 0.825967 6.32578 1.80661 6.32578 3.00019C6.32578 4.19394 7.30624 5.17441 8.5 5.17441C9.69376 5.17441 10.6742 4.19394 10.6742 3.00019C10.6742 1.80643 9.69376 0.825967 8.5 0.825967Z" fill="#0072C2"/>
    </svg>
);

export default VuiHorizontalMoreIcon
